<template>
  <section>
    <div class="content_bg">
      <div class="blue_bg">
        <div class="blue_bg_top">
          <div class="blue_bg_blank"></div>

          <svg
            class="blue_bg_top_core"
            width="2880px"
            height="299px"
            viewBox="0 0 2880 249"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="html"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              opacity="0.200000003"
            >
              <g
                id="BG-Blue"
                transform="translate(0.000000, -509.000000)"
                fill="#215FE6"
              >
                <path
                  d="M0,556.776542 C175.508999,571.043993 399.552916,565.413041 672.131752,539.883686 C858.239063,461.996708 951.718324,588.906667 1131.66075,588.906667 C1356.58878,588.906667 1490.21732,513.371098 1690.38263,513.371098 C1890.54794,513.371098 2264.33583,484.819665 2540.75565,575.148616 C2725.03553,635.367917 2838.11698,652.616083 2880,626.893115 L2880,757.918527 L0,757.918527 L0,556.776542 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </svg>

          <svg
            class="blue_bg_top_core"
            width="2880px"
            height="323px"
            viewBox="0 0 2880 343"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="html"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="BG-Blue"
                transform="translate(0.000000, -457.000000)"
                fill="#215FE6"
              >
                <path
                  d="M2880,799.976684 L0,799.976684 L0,534.19409 C155.639899,419.120727 394.639899,432.850329 717,575.382896 C1037.6871,729.8781 1515.79167,495.352141 1793.5,496.867897 C2160,498.868285 2446.04435,616.046545 2601.025,644.474292 C2704.34543,663.426123 2797.3371,663.426123 2880,644.474292 L2880,799.976684 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </svg>
        </div>
      </div>

      <div class="content">
        <div>
          <p class="welcome_text1">
            <span style="color: #215fe6">먼데이리스</span>는
            <br />
            <span style="color: #f75757">모바일 앱</span> 전문 개발사입니다.
          </p>
          <p class="welcome_text2">
            하이브리드보다 쉬운
            <span style="color: #a91eff">네이티브</span> 개발, 배포, 운영으로<br />
            견적가를 낮추고 퀄리티를 올립니다
          </p>
        </div>

        <div class="aaa" style="position: absolute; top: 20px; right: -100px">
          <svg
            width="356px"
            height="357px"
            viewBox="0 0 356 357"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="html"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
              opacity="0.0500000007"
            >
              <g
                id="index"
                transform="translate(-1066.000000, -104.000000)"
                fill="#00CFE5"
              >
                <g id="BG-Blue" transform="translate(-720.000000, 104.000000)">
                  <path
                    d="M1964,356.069058 C2062.30669,356.069058 2142,276.360285 2142,178.034529 C2142,79.7087738 2062.30669,0 1964,0 C1865.69331,0 1786,79.7087738 1786,178.034529 C1786,276.360285 1865.69331,356.069058 1964,356.069058 Z"
                    id="Ellipse-1"
                  ></path>
                </g>
              </g>
            </g>
          </svg>
        </div>

        <div>
          <img class="welcome_box" src="@/assets/images/welcome_box.png" />
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "../components/Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 840px;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}

.blue_bg {
  position: absolute;
  bottom: 0;
}

.blue_bg_blank {
  position:absolute;
  width: 2880px;
  height: 100px; 
  bottom: 0;
  background-color: #215fe6;
}

.blue_bg_top {
  width: 2880px;
  height: 448px;
  position: relative;
  height: 500px;
}

.blue_bg_top_core {
  position: absolute;
  bottom: 0;
  transform: translateX(-0%);
}

.content {
  display: flex;
  position: absolute;
  top: 0;
  align-items: center;
  justify-content: space-between;
  width: 100vw;
  height: 700px;
  max-width: 1140px;
  padding: 0 20px 0px 20px;
  /* background-color: #f00; */
}

.welcome_box {
  width: 486px;
}

.welcome_text1 {
  font-weight: 700;
  font-size: 48px;
  color: #000000;
  letter-spacing: -1px;
  margin-bottom: 0.5em;
}

.welcome_text2 {
  font-size: 20px;
  color: #495057;
  letter-spacing: 0;
  line-height: 28px;
}
</style>
  